/**
* Licensed Materials - Property of IBM
* IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([
	'underscore',
	'../DashboardTemplatesAPI',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (_, DashboardTemplatesAPI, APIFactory) => {
	class DashboardTemplatesImpl {

		constructor(options) {
			this._logger = options.logger;
			this._feature = options.feature;
			this._getContentSvc = options.getContentSvc;
			this._featureChecker = options.featureChecker;
		}

		destroy() {
			this._feature.destroy();
			this._feature = null;
		}

		getAPI() {
			const isEnabled = !this._featureChecker.checkValue('dashboard', 'dashboardTemplates', 'disabled');
			return isEnabled ? APIFactory.createAPI(this, [DashboardTemplatesAPI]) : APIFactory.createAPI(new DashboardTemplatesAPI(), [DashboardTemplatesAPI]);
		}

		listTemplates() {
			return this._getContentSvc.then((contentSvc) => {
				let url = 'v1/search/cm?filter=type%7Cexploration&filter=tags%7Cdashboard_template';
				let options = {
					type: 'GET',
					data: {
						'fields': 'defaultName,data,id,ancestors,modificationTime'
					}
				};
				return contentSvc.get(url, options)
					.then((response) => {
						let results = response && response.results;
						if (!results) {
							return [];
						}
						results.sort((a, b) => {
							return Date.parse(b.modificationTime) - Date.parse(a.modificationTime);
						});
						return results;
					}).catch(error => {
						this._logger.error(error, this);
						return [];
					});
			});
		}

		getTemplate(id, includeSpec) {
			return this._getContentSvc.then((contentSvc) => {
				let url = contentSvc.getBaseObjectsURL() + '/' + id;
				let options = {
					dataType: 'json',
					type: 'GET'
				};
				if (includeSpec) {
					options.data = {
						fields: 'specification'
					};
				}
				return contentSvc.get(url, options).then((response) => {
					let result = response && response.data && response.data.length && response.data[0];
					if (result.specification) {
						try {
							result.specification = JSON.parse(result.specification);
						} catch (e) {
							return Promise.reject(e);
						}
					}
					return result;
				});
			});
		}

		getThumbnail(id) {
			return this._getContentSvc.then((contentSvc) => {
				let url = contentSvc.getBaseObjectsURL() + '/' + id + '/items?types=graphic';
				let options = {
					type: 'GET',
					data: {
						'fields': 'data'
					}
				};
				return contentSvc.get(url, options).then((response) => {
					let result = response && response.data && response.data.length && response.data[0].data;
					return result;
				});
			});
		}
	}

	return DashboardTemplatesImpl;
});
